import { Controller } from "stimulus";
import 'select2/dist/js/select2.js';

export default class extends Controller {
  static targets = ['trainingSubmit'];

  connect() {
    this.bindAjaxSelect2();

    $('#bulk-assign-journeys').on('shown.bs.modal', () => {
      $('#bulk-assign-journeys').find('.select2-ajax').each((i, element) => {
        this.bindSelect2OnElement(element);
      });
    });

    $('#renewal-modal').on('shown.bs.modal', () => {
      $('#renewal-modal').find('.select2-ajax').each((i, element) => {
        this.bindSelect2OnElement(element);
      });
    });

    $(".select2-ajax").on('select2:select', function() {
      let event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    });

    $('#training_overview_select2').on("select2:select", (e) => {
      var companyId = $('#training_overview_select2').data('company-id')
      var trainingCategoryId = $('#training_overview_select2').val()
      var queryParams = new URL(window.location.href).searchParams.toString();

      window.location.href = `/companies/${companyId}/insights/training_categories/${trainingCategoryId}?${queryParams}`
    });

    $('#l-t-modal').on('shown.bs.modal', () => {
      $('#l-t-modal').find('.select2-ajax').each((i, element) => {
        if ($(element).data('select2')) {
          $(element).select2('destroy');
        }
        this.bindSelect2OnElement(element);
      });
    });
  }

  buildOptionWithIcon(data) {
    if (data.loading) return data.text;

    let iconClass = 'ico-user-single-grey';
    let ariaLabel = 'learner icon';

    if (data.id && (data.id.toString().includes('group') || data.id.toString().includes('category'))) {
      iconClass = 'ico-folder-grey';
      ariaLabel = 'group icon';
    } else if (data.id && data.id.toString().includes('training')) {
      iconClass = 'ico-training-grey';
      ariaLabel = 'training icon';
    }

    const $option = $('<span></span>');
    const $icon = $(
      `<span class="${iconClass} me-2" aria-label="${ariaLabel}"></span>`
    );
    const $text = $(`<span>${data.text}</span>`);

    $option.append($icon).append($text);
    return $option;
  }

  createIconTemplate(data) {
    return this.buildOptionWithIcon(data);
  }

  createSelectionTemplate(data) {
    return data.text;
  }

  createStatusBadgeTemplate(data) {
    const status = data.element?.dataset.status;

    if (!status) return data.text;

    const badgeClasses = {
      published: 'round-badge-live',
      draft: 'round-badge-draft_lemon',
      archived: 'round-badge-secondary',
    };
    const label = data.element.dataset.statusLabel;
    const displayText = data.element.dataset.displayText || data.text;
    const $option = $('<span></span>').addClass('d-flex align-items-center justify-content-between gap-2 w-100');
    const $text = $('<span></span>').addClass('text-truncate').text(displayText);
    const $badge = $('<span></span>').addClass(`round-badge ${badgeClasses[status] || 'round-badge-secondary'}`);

    $badge.append($('<span></span>').addClass('me-0'));
    $badge.append(document.createTextNode(label));
    $option.append($text, $badge);

    return $option;
  }

  bindAjaxSelect2() {
    $('.select2-ajax').each((i, element) => {
      this.bindSelect2OnElement(element);
    });
  }

  bindSelect2OnElement(element) {
    if ($(element).data('select2') && !element.dataset.hasOwnProperty('reinitialize')) {
      return; // Already initialized
    }

    const select2Options = {
      dropdownCssClass: element.dataset.dropdownCssClass || "sidebar-select2 mt-0",
      templateSelection: (data, container) => {
        $(container).addClass('sidebar-select2-selected');
        return this.createSelectionTemplate(data);
      }
    };

    if (element.dataset.hasParentModal == 'true') {
      const dropdownParent = $(element).closest('.modal');
      if (dropdownParent.length) {
        select2Options.dropdownParent = dropdownParent;
      }
    }

    if (element.multiple && element.dataset.preventSelectionsSorting == 'true') {
      $(element).on('select2:select', (event) => {
        const select = $(event.target);

        if (!select.length) return;

        const selectionId = event.params.data.id;

        if (!selectionId) return;

        const option = select.find(`option[value="${selectionId}"]`);

        if (!option.length) return;

        option.detach().appendTo(select);
      });
    }

    if (element.dataset.withoutSearch == 'true') {
      select2Options.minimumResultsForSearch = -1;
    }

    if (element.dataset.placeholder) {
      select2Options.placeholder = element.dataset.placeholder
    }

    if (element.dataset.statusBadges == 'true') {
      select2Options.templateResult = (data) => this.createStatusBadgeTemplate(data);
      select2Options.templateSelection = (data, container) => {
        $(container).addClass('sidebar-select2-selected');
        return this.createStatusBadgeTemplate(data);
      };
    }

    if (element.dataset.multiSelect == 'true') {
      select2Options.closeOnSelect = false;

      select2Options.templateResult = (item) => {
        if (item.element?.tagName === 'OPTGROUP') {

          var optgroup = $(
            `<strong class='clickable' data-controller="select2" data-action='click->select2#optGroupSelection'>` + item.text + '</strong>'
          );

          return optgroup;
        } else {
          return this.createIconTemplate(item);
        }
      }
    }

    if (element.dataset.noAjax == 'true') {
      $(element).select2(select2Options);
      $('.select2-ajax').next('.select2-container').addClass('single-select');
    } else {
      this.bindSelect2withAjax(element);
    }
  }

  bindSelect2withAjax(element) {
    var searchTarget = element.dataset.searchTarget;
    var selectedValues = this.getQueryParam(element.name);
    var hideSelectedResults = element.dataset.hideSelectedResults === 'true';
    var withPagination = element.dataset.paginate === 'true';
    var selectedSetCache = null;

    $(element).select2({
      dropdownCssClass: "sidebar-select2",
      placeholder: 'Start typing name here',
      templateResult: (data) => {
        return this.createIconTemplate(data);
      },

      templateSelection: (data, container) => {
        $(container).addClass('sidebar-select2-selected');
        return this.createSelectionTemplate(data);
      },
      ajax: {
        contentType: 'application/json',
        dataType: 'json',
        url: element.dataset.url,
        data: (params) => {
          const query = {
            [`${searchTarget}`]: params.term,
          };
          if (withPagination) {
            query.page = params.page || 1;
          }

          return query;
        },
        processResults: (data, params) => {
          let results = data.data;

          if (hideSelectedResults) {
            if (!selectedSetCache) {
              selectedSetCache = new Set(($(element).val() || []).map((value) => value.toString()));
            }

            results = results.reduce((acc, item) => {
              if (Array.isArray(item.children)) {
                const filteredChildren = item.children.filter((child) => {
                  return !selectedSetCache.has(child.id?.toString());
                });

                if (filteredChildren.length) {
                  acc.push({...item, children: filteredChildren });
                }
              } else if (!selectedSetCache.has(item.id?.toString())) {
                acc.push(item);
              }

              return acc;
            }, []);
          }

          const response = {
            results: results
          };

          if (withPagination) {
            const currentPage = Number(data.currentPage || params.page || 1);
            const totalPages = Number(data.totalPages || 1);
            response.pagination = { more: currentPage < totalPages };
          }

          return response;
        }
      }
    });

    if (hideSelectedResults) {
      $(element).off('change.select2Cache').on('change.select2Cache', () => {
        selectedSetCache = null;
      });
    }

    $('.select2-ajax').next('.select2-container').addClass('sidebar-filters-select');

    if (selectedValues.length) {
      this.setFilteredDataInDropdown(selectedValues, element.dataset.url, element);
    }
  }

  getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.getAll(name);
  }

  setFilteredDataInDropdown(ids, url, element) {
    $.ajax({
      url: url,
      contentType: 'application/json',
      dataType: 'json',
      data: { 'q[id_in]': ids },
      context: { element: element, selectedIds: ids },
      success: function (response) {
        response.data.map((object) => {
          if (!$(this.element).find('option[value="' + object.id + '"]').length) {
            var newOption = new Option(object.text, object.id, false, false)
            $(this.element).append(newOption).trigger('change')
          }
        });

        $(this.element).val(this.selectedIds).trigger('change');
      }
    });
  }

  optGroupSelection(event) {
    var target = event.target
    var list = $(target).parent().next().children()
    var select2 = $('.select2-ajax')
    var selectedValues = select2.val()

    list.map((index, option) => {
      var id = option.id.split('-').pop()

      if (target.dataset.selected === 'false'){
        if (!selectedValues.includes(id)){
          selectedValues.push(id)
          $(option).addClass('select2-results__option--selected')
        }
      } else {
        if (selectedValues.includes(id)){
          selectedValues.splice(selectedValues.indexOf(id), 1)
          $(option).removeClass('select2-results__option--selected')
        }
      }
    })

    target.dataset.selected = target.dataset.selected === 'false' ? 'true' : 'false'
    select2.val(selectedValues)
    select2.trigger('change')
  }
}
